import React, { useEffect, useState } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { connect } from 'react-redux';
import * as menuActions from '../store/actions/breadcrumb';
import PropTypes from 'prop-types';
import { useLogout } from '../components/Utils';
import { useTranslation } from 'react-i18next';
import '../style/home.css';
import '../style/common.css';
import People from "../assets/People.png";
import Community from "../assets/Community.png";
import Customers from "../assets/Customers.png";
import Investor from "../assets/investor.png";
import Aboutus from "../assets/about-us.JPG";
import * as Styled from '../components/styled-components/Styled-Components';
import SlickCarousel from './SlickCarousel';
import * as charityActions from '../store/actions/charitableActivity';
import { useNavigate } from 'react-router-dom';
import SelfRegistration from './SignIn/SelfRegistration' ;
import * as userActions from '../store/actions/userManagement'
import { useMsal } from "@azure/msal-react";
import { azureLogOut } from "../store/actions/auth";
import InactiveUser from './SignIn/InactiveUser';

const HomePage = ({
  setBreadcrumb, 
  fetchCharityActivities, 
  recentCharityActivity,
  getProfileDetails, 
  userProfile
}) => {
  const { t } = useTranslation('common');
  const onLogout = useLogout();
  const navigate = useNavigate();
  const { instance } = useMsal();

  const [pagination, setPagination] = useState({ limit: 10, offset: 1 });
  const [charityListDetails, setCharityListDetails] = useState([]);
  const [kpiDetails, setKpiDetails] = useState([]);
  const [selfRegistrationDialogOpen, setSelfRegistrationDialogOpen] = useState();
  const [inactiveOpen, setInactiveOpen] = useState();
  const userDetailsLoc = JSON.parse(window.localStorage.getItem("userInfo"));

  const filterValues1 = {
      filterByBusinessUnit: [],
      filterByBusinessUnitLocation: [],
      charityName: "",
      activityName: "",
      startDate: null,
      endDate: null,
      businessId : "",
    }
    useEffect(() => {
            const email = userDetailsLoc?.email || window.sessionStorage.getItem("user_name") 
            const userName = window.localStorage.getItem("userFullName") 
            const tokenDetail = window.localStorage.getItem("tokenDetail")
            const dataObj = {
                email: email,
                token: tokenDetail,
                userName: userName
            }
            getProfileDetails(dataObj,instance);
    }, []);
    useEffect(()=>{
        if(userProfile && userProfile?.data && !userProfile?.data?.isProfileExist && !userProfile?.data?.isUserInActive){
            setSelfRegistrationDialogOpen(true);
            setInactiveOpen(false);
        } else if(userProfile && userProfile?.data && userProfile?.data?.isUserInActive && !userProfile?.data?.isProfileExist) {
            setInactiveOpen(true);
            setSelfRegistrationDialogOpen(false);
        } else {
            setSelfRegistrationDialogOpen(false);
            setInactiveOpen(false);
        }
    },[userProfile])

    useEffect(() => {
      if (fetchCharityActivities) {
          fetchCharityActivities(pagination.limit, pagination.offset, filterValues1);
      }
  }, [fetchCharityActivities]);
  useEffect(()=>{
      if(recentCharityActivity && recentCharityActivity?.status === 200){
        setCharityListDetails(recentCharityActivity?.data?.dashboardCharitableEventDetails);
        setKpiDetails(recentCharityActivity?.data?.dashboardKpiDetails);
      } 
    //   else if (recentCharityActivity && recentCharityActivity?.status === 401) {
    //     onLogout();
    //     azureLogOut(instance);
    //   }
  },[recentCharityActivity])

    useEffect(() => {
    setBreadcrumb('')
    }, []);
    const  aboutus = [
        {
            image: People,
            title: t("Our People"),
            description: "Turpis egestas maecenas pharetra convallis posuere morbi leo urna molestie."
        },
        {
            image: Community,
            title: t("Our Communities"),
            description: "Turpis egestas maecenas pharetra convallis posuere morbi leo urna molestie."
        },
        {
            image: Customers,
            title: t("Our Customers"),
            description: "Turpis egestas maecenas pharetra convallis posuere morbi leo urna molestie."
        },
        {
            image: Investor,
            title: t("Our Investors"),
            description: "Turpis egestas maecenas pharetra convallis posuere morbi leo urna molestie."
        }
    ]

    const handleDialogClose = () => {
        setSelfRegistrationDialogOpen(false);
    };
    const handleInactiveClose = () => {
        setInactiveOpen(false);
    };
  return (
    <div>
      <Grid container>
        <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
            <Grid item className='bannerImage'>
                <Grid item className='gradientHolder'>
                    <Typography variant="h3" component="h2" style={{marginBottom: 20, fontSize: 40}} color="#05AAE8">
                        <b>{t("Making Peoples Lives Better")}</b>
                    </Typography>
                    <Typography variant="h6" style={{marginBottom: 20}} color="#fff">
                        <b>{t("Our Strength is in Our People")}</b>
                    </Typography>
                    <Grid item style={{borderLeft: '3px solid #05AAE8',  paddingLeft: 20}}>
                        <Typography variant="h6" component="h2" style={{marginBottom: 20, fontSize: 16}} color="#fff">
                            {t("Enriching lives in our communities has been one of the greatest returns on investment. From working with non-profit organizations on sustainability efforts to raising funds for children in need, and supporting the development of young talent nationwide, Martinrea values and instills cultural traditions we are proud to represent globally. Our work in communities never stops – it’s our mission to making people’s lives better.")}
                        </Typography>
                    </Grid>
                </Grid>
                
            </Grid>
        </Grid>
      </Grid>
      <Grid container className='bannerKpi' spacing={2}>
        
        <Grid item className='bannerKpiSection'>
            <Grid item xs={12} sm={12} xl={12} lg={12} md={12} className='kpiHeader'>
                <h1 className='page-heading' style={{fontSize: 34}}><b>{t("Total impacts")}</b></h1>
                <div className='gradientDivider'></div>
            </Grid>
            <Grid item className='bannerKpiHolder'>
                <Grid item xs={12} sm={12} xl={2} lg={2} md={6} className='kpiDiv'>
                    <Typography variant="h3" component="h2" className='kpiValue'>
                        <b>{kpiDetails?.totalCharitableActivities}</b>
                    </Typography>
                    <div className='blue-divider'></div>
                    <Typography variant="h3" component="h2" className='kpiKey'>
                        <b> {t("Charitable Activities")}</b>
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} xl={2} lg={2} md={6} className='kpiDiv'>
                    <Typography variant="h3" component="h2" className='kpiValue'>
                        <b>{kpiDetails?.totalEmployeeFunds}</b>
                    </Typography>
                    <div className='blue-divider'></div>
                    <Typography variant="h3" component="h2" className='kpiKey'>
                        <b> {t('Employee Funds in CAD')}</b>
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} xl={2} lg={2} md={6} className='kpiDiv'>
                    <Typography variant="h3" component="h2" className='kpiValue'>
                        <b>{kpiDetails?.totalFunds}</b>
                    </Typography>
                    <div className='blue-divider'></div>
                    <Typography variant="h3" component="h2" className='kpiKey'>
                        <b> {t('Martinrea Funds in CAD')}</b>
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} xl={2} lg={2} md={4} className='kpiDiv'>
                    <Typography variant="h3" component="h2" className='kpiValue'>
                        <b>{kpiDetails?.totalVolunteerHours}</b>
                    </Typography>
                    <div className='blue-divider'></div>
                    <Typography variant="h3" component="h2" className='kpiKey'>
                        <b> {t("Volunteer Hours")}</b>
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={12} xl={2} lg={2} md={6} className='kpiDiv'>
                    <Typography variant="h3" component="h2" className='kpiValue'>
                        <b>{kpiDetails?.totalUsers}</b>
                    </Typography>
                    <div className='blue-divider'></div>
                    <Typography variant="h3" component="h2" className='kpiKey'>
                        <b> {t("Users")}</b>
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{  display: 'flex', padding: '40px 0', marginBottom: 70 }}>
            <Grid item xs={12} sm={0} md={0} xl={1} lg={1} ></Grid>
            <Grid item xs={12} sm={12} md={6} xl={5} lg={5} style={{ display: 'flex', flexDirection: 'column' }}>
                <Box><img className='all-about-us-img' src={Aboutus} alt="Large" style={{ width: '95%', height: '520px', objectFit: 'contain' }} /></Box>
            </Grid>
            <Grid item xs={12} sm={12} md={6} xl={5} lg={5} style={{ display: 'flex', flexDirection: 'column' }}>
                <Box style={{ justifyContent: 'space-between', display: "flex",
                flexDirection: "column"}}>
                <Typography variant="h3" component="h2" className='kpiKey' style={{marginBottom: 10}}>
                    <b>{t("Who we are")}</b>
                </Typography>
                <Typography variant="h3" component="h2" className='kpiValue'>
                    <b>{t("About Us")}</b>
                </Typography>
                <div className='gradientDivider'></div>
                <Typography variant="h3" component="h2" className='kpicontent' style={{fontSize: 13}}>
                    {t("aboutUsText")}
                </Typography>
                    <div style={{display: 'flex', gap: 5, flexDirection: 'column', marginTop: 30 }}>
                        {aboutus?.map((item, index) => (
                            <Grid container spacing={2} alignItems="center" key={index}>
                                <Grid item  xs={3} sm={3} md={2} xl={1.5} lg={1.5}>
                                    <Box><img src={item.image} alt={`Row ${item?.title}`} style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '8px'}}/></Box>
                                </Grid>
                                <Grid item xs={9} sm={9} md={10} xl={9.5} lg={9.5} style={{paddingLeft: 0}}>
                                    <Typography variant="h6" gutterBottom>
                                        <b style={{fontSize: 20}}>{item.title}</b>
                                    </Typography>
                                    {/* <Typography variant="body2" color="textSecondary">
                                        {item.description}
                                    </Typography> */}
                                </Grid>
                            </Grid>
                        ))}
                    </div>
                </Box>
            </Grid>
            <Grid item xs={12} sm={0} md={0} xl={1} lg={1} ></Grid>
        </Grid>
        <Grid container spacing={2} style={{background: '#F5F5F5', padding: "40px 30px", display: 'flex', justifyContent: 'center'}}>
            {/* <Grid item xs={0} sm={0} md={0} xl={1} lg={0} ></Grid> */}
            <div style={{width: "85%", display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <Grid item xs={12} sm={12} xl={5} lg={6} md={6}>
                    <h1 className='page-heading' style={{fontSize: 34}}><b>{t("Charitable Activities")}</b></h1>
                    <div className='gradientDivider'></div>
                </Grid>
                <Grid item xs={12} sm={12} xl={5} lg={6} md={6} sx={{textAlign: {xs:"right", sm:"right", lg:"right", xl:"right",md:"right"}}}>
                    <div>
                    <Styled.PrimaryButton
                        variant="contained"
                        className="xs-bold"
                        onClick={() => navigate('/gallery', { state: { initState: true } })}
                    >
                        {t("View All")}
                    </Styled.PrimaryButton>
                    </div>
                </Grid>
            </div>
            
            {/* <Grid item xs={0} sm={0} md={0} xl={1} lg={0} ></Grid> */}
      </Grid>
      <Grid container spacing={2} style={{background: '#F5F5F5', padding: "0 0 100px 0"}}>
            <Grid item xs={0} sm={0} md={0} xl={1} lg={1} ></Grid>
            <Grid item xs={12} sm={12} xl={10} lg={10} md={10}>
                <SlickCarousel charityData={charityListDetails}/>
            </Grid>
            <Grid item xs={0} sm={0} md={0} xl={1} lg={1} ></Grid>
      </Grid>
      {selfRegistrationDialogOpen && (
          <SelfRegistration 
          openDialog={selfRegistrationDialogOpen}
          onClose={handleDialogClose}
          />
      )}
      {inactiveOpen && (
          <InactiveUser 
          openDialog={inactiveOpen}
          onClose={handleInactiveClose}
          azureLogOut={()=>{azureLogOut(instance)}}
          userProfile={userProfile}
          />
      )}
      </div>
  );
}
const mapStateToProps = (state) => ({ 
    recentCharityActivity: state.charitableActivity.recentCharityActivity,
    userProfile: state.userReducer.userProfile,
    })
  
  const mapDispatchToProps = (dispatch) => {
      return {
          fetchCharityActivities: (limit, offset, filter, search) => dispatch(charityActions.getRecentCharitableActivityList(limit, offset, filter, search)),
          setBreadcrumb: (menu) => dispatch(menuActions.changeMenu(menu)),
          getProfileDetails: (dataObj, instance) => dispatch(userActions.getProfileDetails(dataObj, instance)),
      };
  };
  HomePage.propTypes = {
      fetchCharityActivities: PropTypes.func.isRequired,
      setBreadcrumb: PropTypes.func.isRequired,
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(HomePage);